import React, { PureComponent, PropTypes } from 'react'
import { FormattedDate, intlShape } from 'react-intl'
import * as shapes from '../../constant/shapes'
import { Link } from 'react-router'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'
import MiniPlayer from '../../components/miniPlayer/MiniPlayer'
import appConst from '../../constant/appConst'

class FocusAlbumCard extends PureComponent {

	render() {
		const { album, forceCardHeight, forceImageHeight, current, playing } = this.props
		const { intl } = this.context

		const releaseYear = album.released_at ? new Date(album.released_at * 1000).getFullYear() : undefined

		let description = ''
		if (album.description) {
			if(album.description.length > appConst.albumCardDescMaxLength) {
				const maxPos = album.description.lastIndexOf(' ', appConst.albumCardDescMaxLength)
				description = `${album.description.substring(0, maxPos)}...`
			} else {
				description = album.description
			}
		}

		return (
			<li className={`item ${current ? (playing ? 'isPlaying' : 'isPause' ) : ''}`} style={forceCardHeight ? { height: forceCardHeight } : {}}>
				<div className="item-overlay" />
				<div className="item-info">
					{album.released_at && <span className="item-labelize">
						<FormattedDate
							value={new Date(album.released_at * 1000)}
							day="numeric"
							month="short"
							year="numeric"
						/>
					</span>}
					<p className="c1 t3">{album.title}</p>
					<p className="c1 item-dext t5" dangerouslySetInnerHTML={{ __html: description }} />
					<p className="c1 item-artist">
						{album.artist && <Link to={`/artist/${album.artist.id}`} className="c7 artist-link">{album.artist.name}</Link>}
						{releaseYear ? intl.formatMessage({ id: 'focus.albumOverlay' }, { releaseYear, genre: album.genre }) : null}
					</p>
					<Link to={`/album/${album.id}`} className="item-cover-link" />
					<MiniPlayer
						element={album}
						buttonClassName="bt1 white item-play"
						type={ORIGIN_PLAYQUEUE_TYPES.album}
						sampleable={album.sampleable}
					/>
				</div>
				<img
					src={album.image || ''}
					className="item-cover"
					alt=""
					height="295"
					width="295"
					style={forceImageHeight ? { height: forceImageHeight } : {}}
				/>
				<div className="item-meta">
					{album.award && <span className="item-badge text-overflow" title={album.award}>{album.award}</span>}
					<h3 className={`item-title text-overflow ${(album.award ? '' : 'no-badge')}`} title={album.title}>
						<Link to={`/album/${album.id}`}>{album.title}</Link>
					</h3>
					{album.artist && <p className="c3 text-overflow" title={album.artist.name}>
						<Link to={`/artist/${album.artist.id}`}>{album.artist.name}</Link>
					</p>}
				</div>
			</li>
		)
	}

}

FocusAlbumCard.propTypes = {
	album: shapes.albumCard,
	forceCardHeight: PropTypes.number,
	forceImageHeight: PropTypes.number,
	current: PropTypes.bool,
	playing: PropTypes.bool
}

FocusAlbumCard.contextTypes = {
	intl: intlShape
}

export default FocusAlbumCard



// WEBPACK FOOTER //
// ./src/pages/focus/FocusAlbumCard.jsx